export default "__VITE_ASSET__9tVCRsGi__"